import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import {
  priceFieldProps,
  priceRegisterConfig,
  urlRegisterConfig,
} from './Fields/config'
import ConfirmedBooking from './Fields/ConfirmedBooking'
import Input from './Fields/RHFInput'
import TextArea from './Fields/RHFTextArea'
import StartEndAddressFields from './Fields/StartEndAddressFields'
import StartEndDateTimeFields from './Fields/StartEndDateTimeFields'
import { useDefaultDatePickerMonthYear } from './Hooks/useDefaultDates'
import { CreateTrainItemViewModel } from '../Create/models'
import { UpdateTrainItemViewModel } from '../Edit/models'

import { AutocompletePlaceParam } from 'tripPlanner/types/google'

const AUTOCOMPLETE_TYPES: AutocompletePlaceParam = [
  'train_station',
  'bus_station',
  'transit_station',
  'travel_agency',
  'route',
]

interface Props {
  tripId: string
}

const TrainFields = ({ tripId }: Props) => {
  const methods = useFormContext<
    CreateTrainItemViewModel | UpdateTrainItemViewModel
  >()
  const { control, watch, register } = methods
  const watchBooked = watch('isBooked')

  const { defaultMonth, defaultYear } = useDefaultDatePickerMonthYear({
    tripId,
  })

  return (
    <>
      <StartEndAddressFields
        autocompleteTypes={AUTOCOMPLETE_TYPES}
        tripId={tripId}
      />
      <StartEndDateTimeFields
        startDateLabel="Departure date"
        endDateLabel="Arrival date"
        defaultMonth={defaultMonth}
        defaultYear={defaultYear}
      />

      <Input
        {...register('operatorName')}
        label="Operator"
        placeholder="Operator"
      />

      <Input
        {...register('url', { ...urlRegisterConfig })}
        label="Website"
        placeholder="Website"
      />

      <Controller
        name="isBooked"
        control={control}
        render={({ field }) => (
          <ConfirmedBooking
            toggled={!!field.value}
            onToggle={() => field.onChange(!field.value)}
          />
        )}
      />

      {watchBooked && (
        <>
          <Input
            {...register('confirmationCode')}
            label="Confirmation number"
            placeholder="Confirmation number"
          />
          <Input {...register('seat')} label="Seat" placeholder="Seat number" />
        </>
      )}

      <Input
        {...register('price', { ...priceRegisterConfig })}
        label="Price"
        placeholder="Price"
        {...priceFieldProps}
      />

      <TextArea
        {...register('notes')}
        placeholder="Add notes about this booking"
        label="Additional notes"
        resize="vertical"
      />
    </>
  )
}

export default TrainFields
